import React from 'react';
import './index.scss';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { HttpStatusCode } from '@/fetch/core/constant';
import { message } from 'antd';
import CollectMapApi from '@/fetch/bussiness/collectMap';
import classNames from 'classnames';
import { SystemStateEnum } from '@/utils/constant';
const fetchApi = new CollectMapApi();

const ResumeCollectMap = (props: {
  vehicleName: string;
  cockpitNumber: string;
  taskId: number;
  bindingState: boolean;
  systemState: any;
  onClose: any;
}) => {
  const { login } = useSelector((state: RootState) => state);
  const { cockpitNumber, vehicleName, onClose, taskId, bindingState } = props;
  const ResumeCollectMap = async () => {
    try {
      if (!login.userInfo?.userName || !cockpitNumber || !vehicleName) {
        return;
      }
      const res = await fetchApi.switchCollection({
        cockpitNumber,
        vehicleName,
        taskId,
        action: 1,
      });
      if (res.code === HttpStatusCode.Success) {
        message.success('恢复采集成功');
        onClose && onClose();
      } else {
        message.error(res.message || '网络请求错误');
        return;
      }
    } catch (e) {
      message.error(`${vehicleName}恢复采集失败`);
      return;
    }
  };
  return (
    <>
      <li
        className={classNames('btn-item', {
          'resume-collect-map':
            bindingState && props.systemState !== SystemStateEnum.OFFLINE,
          'resume-collect-map-disabled':
            !bindingState ||
            !props.systemState ||
            props.systemState === SystemStateEnum.OFFLINE,
        })}
        onClick={() => {
          if (
            !bindingState ||
            !props.systemState ||
            props.systemState === SystemStateEnum.OFFLINE
          ) {
            message.error('系统离线，无法恢复采集');
            return;
          }
          ResumeCollectMap();
        }}
      >
        <i>继续采集</i>
      </li>
    </>
  );
};

export default React.memo(ResumeCollectMap);
